import { render, staticRenderFns } from "./ElementPopupDestination.vue?vue&type=template&id=88b0314c&scoped=true&"
import script from "./ElementPopupDestination.vue?vue&type=script&lang=js&"
export * from "./ElementPopupDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b0314c",
  null
  
)

export default component.exports